import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import { IconLabelBox } from '../../IconLabelBox';
import { OkFilledIcon, OkIcon, OkPlusIcon } from './Icons';
import { useStyles } from './style';

interface Props {
  okWithWarnings?: boolean;
  filled?: boolean;
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

const ReducedIcon: FC<{
  filled: boolean;
  okWithWarnings: boolean;
  style?: CSSProperties;
}> = ({ filled, okWithWarnings, style }) => {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <>
      {/* eslint-disable-next-line no-nested-ternary */}
      {filled ? (
        <OkFilledIcon
          htmlColor={theme.palette.success.main}
          className={classes.icon}
          style={style}
        />
      ) : okWithWarnings ? (
        <OkPlusIcon
          htmlColor={theme.palette.success.main}
          className={classes.icon}
          style={style}
        />
      ) : (
        <OkIcon
          htmlColor={theme.palette.success.main}
          className={classes.icon}
          style={style}
        />
      )}
    </>
  );
};

export const PassedIcon: FC<Props> = ({
  okWithWarnings = false,
  filled = false,
  style,
  variant = 'default',
}) => {
  const theme = useTheme();
  return (
    <WbInfoTooltip
      title={
        okWithWarnings ? 'Completed with warnings' : 'Completed with success'
      }
      icon={
        <span>
          {variant === 'reduced' ? (
            <ReducedIcon
              filled={filled}
              okWithWarnings={okWithWarnings}
              style={style}
            />
          ) : (
            <IconLabelBox
              label="Success"
              backgroundColor={theme.palette.success.main}
              value="OK"
            />
          )}
        </span>
      }
    />
  );
};
